import { useEffect } from 'react';
import { usePracticeLabs } from '@witmetrics/data-store';
import { searchByKey } from '@witmetrics/utils/arrays';
import SearchableDropdown, {
  type SearchableDropdownOption,
} from '@/components/inputs/SearchableDropdown';

export type LabFieldProps = {
  disabled?: boolean;
  className?: string;
  value?: SearchableDropdownOption<number> | null;
  onSelect: (lab: SearchableDropdownOption<number> | null) => void;
};

export default function LabField({
  disabled,
  className,
  value,
  onSelect,
}: LabFieldProps) {
  const labs = usePracticeLabs();
  const options = labs.map((lab) => ({
    value: lab.id,
    label: lab.name,
  }));

  useEffect(() => {
    if (!value && labs.length === 1) {
      // If there's only one lab, automatically select it
      onSelect(options[0]);
    }
  }, [labs]);

  return (
    <SearchableDropdown<number>
      disabled={disabled}
      className={className}
      label="Select a Lab"
      value={value}
      initialOptions={value ? [value] : options}
      onSearch={async (search) => searchByKey(options, 'label', search)}
      onSelect={onSelect}
    />
  );
}
